import React from "react";

const TabularReportIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.826"
      height="34.825"
      viewBox="0 0 34.826 34.825"
    >
      <path
        id="db93"
        d="M221.635,213.736h1.272l3.9,6.5.383.636-1.274.765-.382-.638-2.616-4.36v9.182h-9.757v-1.3h8.456v-7.882L219.005,221l-.382.638-1.272-.765.382-.636Zm-17.427-.818h5.8v14.511h-5.8Zm8.706-8.706h14.511v5.8H212.915Zm-8.706,0h5.8v5.8h-5.8Zm-2.9-5.8a2.9,2.9,0,0,0-2.9,2.9v29.02a2.9,2.9,0,0,0,2.9,2.9h29.021a2.9,2.9,0,0,0,2.9-2.9v-29.02a2.9,2.9,0,0,0-2.9-2.9Z"
        transform="translate(-198.404 -198.406)"
        fill={fill ? fill : "#a07eff"}
      />
    </svg>
  );
};
export default TabularReportIcon;
